var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiveStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 18,
    viewBox: "0 0 97 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0662 0.000976562H0V18.001H18.0662V0.000976562Z",
    fill: "#00B67A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6384 0.000976562H19.5723V18.001H37.6384V0.000976562Z",
    fill: "#00B67A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2088 0.000976562H39.1426V18.001H57.2088V0.000976562Z",
    fill: "#00B67A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.781 0.000976562H58.7148V18.001H76.781V0.000976562Z",
    fill: "#00B67A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3533 0.000976562H78.2871V18.001H96.3533V0.000976562Z",
    fill: "#00B67A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03215 12.1328L11.7797 11.4391L12.9277 14.9641L9.03215 12.1328ZM15.3553 7.57656H10.5188L9.03215 3.03906L7.54545 7.57656H2.70898L6.62332 10.3891L5.13663 14.9266L9.05096 12.1141L11.4598 10.3891L15.3553 7.57656Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6044 12.1326L31.352 11.4388L32.4999 14.9638L28.6044 12.1326ZM34.9276 7.57632H30.0911L28.6044 3.03882L27.1177 7.57632H22.2812L26.1956 10.3888L24.7089 14.9263L28.6232 12.1138L31.0321 10.3888L34.9276 7.57632Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1747 12.1328L50.9223 11.4391L52.0702 14.9641L48.1747 12.1328ZM54.4979 7.57656H49.6614L48.1747 3.03906L46.688 7.57656H41.8516L45.7659 10.3891L44.2792 14.9266L48.1935 12.1141L50.6024 10.3891L54.4979 7.57656Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.747 12.1328L70.4946 11.4391L71.6425 14.9641L67.747 12.1328ZM74.0702 7.57656H69.2337L67.747 3.03906L66.2603 7.57656H61.4238L65.3382 10.3891L63.8515 14.9266L67.7658 12.1141L70.1746 10.3891L74.0702 7.57656Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3193 12.1328L90.0668 11.4391L91.2148 14.9641L87.3193 12.1328ZM93.6424 7.57656H88.806L87.3193 3.03906L85.8326 7.57656H80.9961L84.9104 10.3891L83.4237 14.9266L87.3381 12.1141L89.7469 10.3891L93.6424 7.57656Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiveStar);
export default __webpack_public_path__ + "static/media/five-star.01f4916aaa7247b32941ba12f69f9fbc.svg";
export { ForwardRef as ReactComponent };